import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { Section } from '../../../models';
import { ElevationInstallationFieldIds } from './config-models';
import { field } from '../../../core/field-schema';
import { required, maxLength, pattern } from '../../../core/validator-builders';
import { InstallationConfigState, InstallationTypeSectionIds } from '../../common.models';

const getReferencePointValidators = (isMetric: boolean) => {
    const validators = [required(), maxLength({ value: 100 })];

    if (isMetric) {
        return [
            ...validators,
            pattern({
                value: REGEX_CONFIG.numeric0_99999with1DecimalPlacePattern,
                message: 'HOME.MAP.MARKER_LOCATION_DETAIL.ELEVATION_REF_METRIC_PRECISION_ERROR',
            }),
        ];
    }

    return [
        ...validators,
        pattern({
            value: REGEX_CONFIG.numeric0_99999with2DecimalPlacesPattern,
            message: 'HOME.MAP.MARKER_LOCATION_DETAIL.ELEVATION_REF_PRECISION_ERROR',
        }),
    ];
};

const getPhysicalOffsetValidators = (isMetric: boolean) => {
    const validators = [required(), maxLength({ value: 100 })];

    if (isMetric) {
        return [
            ...validators,
            pattern({
                value: REGEX_CONFIG.negative0_9999with1DecimalPlacePattern,
                message: 'HOME.MAP.MARKER_LOCATION_DETAIL.ELEVATION_PHY_METRIC_PRECISION_ERROR',
            }),
        ];
    }

    return [
        ...validators,
        pattern({
            value: REGEX_CONFIG.negative0_9999with2DecimalPlacesPattern,
            message: 'HOME.MAP.MARKER_LOCATION_DETAIL.ELEVATION_PHY_PRECISION_ERROR',
        }),
    ];
};
export const elevationInstallationConfig = (state: InstallationConfigState): Section => {
    const details = state.locationDetails && state.locationDetails.length > 0 ? state.locationDetails[0] : null;
    const settings = state.settings;
    if (!settings) {
        throw new Error('Location card settings are not loaded.');
    }

    return {
        info: {
            id: InstallationTypeSectionIds.Elevation,
            title: '',
            displayTitle: false,
        },
        rows: [
            {
                info: {
                    id: 'elevation-row-1',
                    panelClass: 'custom-50p',
                },
                items: [
                    field.number(ElevationInstallationFieldIds.ReferencePoint, 'referencePoint', {
                        value: details ? details.referencePoint : null,
                        placeholder: 'HOME.MAP.MARKER_LOCATION_DETAIL.REFERENCE_POINT',
                        placeholderSuffix: settings.elevationUnit,
                        validators: getReferencePointValidators(settings.isMetric),
                        panelClass: 'each-Item full-width required',
                    }),
                    field.text(ElevationInstallationFieldIds.Datum, 'datum', {
                        value: details ? details.datum : null,
                        placeholder: 'HOME.MAP.MARKER_LOCATION_DETAIL.DATUM',
                        validators: [
                            required(),
                            maxLength({ value: 16 }),
                            pattern({
                                value: REGEX_CONFIG.alphaNumericWithoutSpace_16CharsPattern,
                                message: 'COMMON.INVALID_FORMAT',
                            }),
                        ],
                        panelClass: 'each-Item full-width required',
                    }),
                ],
            },
            {
                info: {
                    id: 'physical-offset-row',
                    panelClass: 'custom-50p pad-b-15',
                },
                items: [
                    field.number(ElevationInstallationFieldIds.PhysicalOffset, 'physicalOffset', {
                        value: details ? details.physicalOffset : 0,
                        placeholder: 'HOME.MAP.MARKER_LOCATION_DETAIL.PHYSICAL_OFFSET',
                        placeholderSuffix: settings.elevationUnit,
                        validators: getPhysicalOffsetValidators(settings.isMetric),
                        panelClass: 'each-Item full-width required',
                    }),
                ],
            },
        ],
    };
};
